import { useMemo } from 'react';
import { Box } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import {
  MatchIconV2,
  PointIconV2,
  TargetIconV2
} from '@setvi/shared/components/sicons';

import {
  AnalyticsColors,
  AnalyticsLabels
} from 'pages/auto-rfq/components/analytics';

export const AnalyticsIcons = {
  ExactMatch: (
    <TargetIconV2 fontSize="small" fill={AnalyticsColors.ExactMatch} />
  ),
  CloseMatch: (
    <PointIconV2 fontSize="small" fill={AnalyticsColors.CloseMatch} />
  ),
  PossibleMatch: (
    <MatchIconV2 fontSize="small" fill={AnalyticsColors.PossibleMatch} />
  )
};

const MatchIndicator = ({
  percentage,
  disabled
}: {
  percentage: number;
  disabled?: boolean;
}) => {
  const currValue = useMemo(() => {
    if (percentage === 100) return 'ExactMatch';
    if (percentage >= 80) return 'CloseMatch';

    return 'PossibleMatch';
  }, [percentage]);

  return (
    <Box
      style={{
        width: 'fit-content',
        border: `0.5px solid ${disabled ? '#AFBAC6' : AnalyticsColors[currValue]}`,
        padding: '4px 8px',
        borderRadius: 16,
        display: 'flex',
        alignItems: 'center',
        background: disabled ? '#EEF0F2' : 'transparent',
        gap: 4
      }}>
      {/* AnalyticsIcons[currValue] */}
      <SText
        title={AnalyticsLabels[currValue]}
        fontColor={disabled ? '#AFBAC6' : AnalyticsColors[currValue]}
        weight="semibold"
        style={{
          fontSize: 12
        }}
      />
    </Box>
  );
};

export default MatchIndicator;
